import {
  email_repository,
} from '@/repositories';

const state = () => ({
  bat_list: [],
  email_templates: [],
  email_templates_tags: [],
  template: null,
});

const getters = {
  batList: (state) => state.bat_list,
  emailTemplates: (state) => state.email_templates,
  emailTemplatesTags: (state) => state.email_templates_tags,
  template: (state) => state.template,
};

const actions = {
  async searchEmailTemplates({commit}) {
    const result = await email_repository.searchEmailTemplates();
    let template_list = result.template_list.reverse();

    template_list.map((template) => {
      template.first_tag_list = [];
      template.last_tag_list = [];
    });
    commit('set_email_templates', template_list);

    return result;
  },
  async searchEmailTemplatesTags({commit, rootState}) {
    const result = await email_repository.searchEmailTemplatesTags({
      user_id_list: [ rootState.user.token_data.user_id ],
    });

    const templates_tags_list = result.tag_list
      .map((tag) => ({
        ...tag,
        checked: false,
      }));

    commit('set_email_templates_tags', templates_tags_list);

    return templates_tags_list;
  },
  async createTemplatesTag({dispatch, rootState}, data) {
    const {
      color,
      name,
    } = data;

    const created_tag = await email_repository.createTemplatesTag({
      color,
      name,
      organization_id: rootState.user.token_data.organization_id,
      user_id: rootState.user.token_data.user_id,
    });

    await dispatch('searchEmailTemplatesTags');

    return created_tag;
  },
  async updateTemplatesTag({dispatch}, data) {
    const {
      color,
      name,
      tag_id,
    } = data;

    await email_repository.updateTemplatesTag({
      color,
      name,
      tag_id,
    });

    await dispatch('searchEmailTemplatesTags');
  },
  async deleteTemplatesTag({dispatch}, data) {
    const {
      tag_id,
    } = data;

    await email_repository.deleteTemplatesTag({
      tag_id,
    });

    await dispatch('searchEmailTemplatesTags');
  },
  async linkTemplateTag(_, data) {
    const {
      tag_id,
      template_id,
    } = data;

    await email_repository.linkTemplateTag({
      tag_id,
      template_id,
    });
  },
  async unlinkTemplateTag(_, data) {
    const {
      tag_id,
      template_id,
    } = data;

    await email_repository.unlinkTemplateTag({
      tag_id,
      template_id,
    });
  },
  async sendHelpMessageToSupport(_, data) {
    const result = await email_repository.sendHelpMessageToSupport(data);

    return result;
  },
  async sendAddUserSmartDataRequest(_, data) {
    const result = await email_repository.sendAddUserSmartDataRequest(data);

    return result;
  },
  async sendDemandForNewUser(_, data) {
    const result = await email_repository.sendDemandForNewUser(data);

    return result;
  },
  async sendMail(_, mail_data) {
    const result = await email_repository.sendMail(mail_data);

    return result;
  },
  async getTemplate({commit}, input) {
    const {
      template_id,
    } = input;

    let template = await email_repository.getTemplate(template_id);

    const {
      statistics,
    } = template;

    const {
      mail_sent_count,
      mail_opened_count,
      mail_clicked_count,
      mail_replied_count,
    } = statistics;

    if (mail_sent_count === 0) {
      template.statistics_percentage = {
        mail_opened_count: 0,
        mail_clicked_count: 0,
        mail_replied_count: 0,
      };
    } else {
      template.statistics_percentage = {
        mail_opened_count: Math.min(100, Math.ceil((mail_opened_count * 100) / mail_sent_count)),
        mail_clicked_count: Math.min(100, Math.ceil((mail_clicked_count * 100) / mail_sent_count)),
        mail_replied_count: Math.min(100, Math.ceil((mail_replied_count * 100) / mail_sent_count)),
      };
    }

    commit('set_email_template', template);

    return template;
  },
  async createTemplate({dispatch}, input) {
    const template = await email_repository.createTemplate(input);

    await dispatch('searchEmailTemplates');

    return template;
  },
  async updateTemplate({dispatch}, input) {
    await email_repository.updateTemplate({
      html_content: input.html_content,
      name: input.name,
      plain_content:input.plain_content,
      subject: input.subject,
    }, input.id
    );

    return await dispatch('searchEmailTemplates');
  },
  async deleteTemplate({dispatch}, input) {
    await email_repository.deleteTemplate(input.id);

    return await dispatch('searchEmailTemplates');
  },
  async getBats({ commit, dispatch, rootState }) {
    const bat_list = await email_repository.getBats({
      user_id_list: [rootState.user.token_data.user_id],
    });

    const personnal_email = await dispatch('getPersonnalEmail');

    bat_list.unshift({
      email: `${personnal_email} (moi)`,
      id: 0,
    });

    commit('set_bat_list', bat_list);

    return bat_list;
  },
  async updateBats({ commit, dispatch }, input) {
    const new_bat_list = input.bat_list.map((bat) => ({
      email: bat,
    }));

    const bat_list = await email_repository.updateBats(new_bat_list);

    const personnal_email = await dispatch('getPersonnalEmail');

    bat_list.unshift({
      email: `${personnal_email} (moi)`,
      id: 0,
    });

    commit('set_bat_list', bat_list);

    return bat_list;
  },
  getPersonnalEmail({ rootState }) {
    const {
      nylas_credentials,
    } = rootState.nylas;

    return (
      nylas_credentials !== null
      && nylas_credentials !== undefined
      && Object.keys(nylas_credentials).length > 0
    )
      ? nylas_credentials.email
      : rootState.user.user_data.email;
  },
  async sendConnectionEmail(_, input) {
    const result = await email_repository.sendConnectionEmail(input);

    return result;
  },
  async sendLinkedinConnectionEmail(_, input) {
    const result = await email_repository.sendLinkedinConnectionEmail(input);

    return result;
  },
  async getSignaturesOfOtherUsers(_, input) {
    const result = await email_repository.getSignaturesOfOtherUsers(input);

    return result;
  },
  async createSignatureForOtherUser(_, input) {
    const result = await email_repository.createSignatureForOtherUser(input);

    return result;
  },
  async updateSignatureOfOtherUser(_, input) {
    const result = await email_repository.updateSignatureOfOtherUser(input);

    return result;
  },
  async deleteSignatureOfOtherUser(_, signature_id) {
    const result = await email_repository.deleteSignatureOfOtherUser(signature_id);

    return result;
  },
  async unsubscribe(_, { token }) {
    const result = await email_repository.unsubscribe(token);

    return result;
  },
};

const mutations = {
  set_bat_list(state, bat_list) {
    state.bat_list = bat_list;
  },
  set_email_template(state, template) {
    state.template = template;
  },
  set_email_templates(state, email_templates) {
    state.email_templates = email_templates;
  },
  set_email_templates_tags(state, email_templates_tags) {
    state.email_templates_tags = email_templates_tags;
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
